
import RestService from "../../services/rest.service"

export const getEmailNotificationList = (code) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/notification-center/email`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getEmailNotificationDetail = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/notification-center/email/${serial}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const putEmailNotificationDetail = (serial, body) => (dispatch) => {
  let reqBody = {
    data: body
  }
  return new Promise((resolve, reject) => {
    RestService.put(`app/admin/notification-center/email/${serial}`, reqBody).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}